<template>
  <div>Registration Confirmation...</div>
</template>
<script>
import * as axios from "axios";
import { errorMessageMixin } from "../shared";

export default {
  name: "Confirmation",
  mixins: [errorMessageMixin],
  async created() {
    console.log("the key is", this.$route.query.key);
    let key = this.$route.query.key;
    if (key) {
      await confirmKey(key);
    }
  }
};

const confirmKey = async function(key) {
  try {
    console.log("im calling confirm");
    const response = await axios.post(
      process.env.VUE_APP_SERVICE_URL + `/register?key=` + key
    );
    console.log("response", response);
    if (response.status != 200) {
      throw Error(response.message);
    }
    this.$router.push({
      name: "Login",
      params: { msg: "Registration complete. Please login." }
    });
  } catch (err) {
    this.$store.state.error = this.errorMessage(err);
    this.$store.state.snackbar = true;
    console.log(err);

    this.$router.push({ name: "Login" });
  }
};
</script>
